import { Maybe } from 'graphql/jsutils/Maybe';
import { TUI_IS_MOBILE_RES } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

import { IsTruePipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-conditional-link',
  templateUrl: './conditional-link.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    IsTruePipe,
    NgIf,
    NgTemplateOutlet,
    RouterLink,
  ],
})
export class ConditionalLinkComponent {
  public readonly isMobileRes$ = inject(TUI_IS_MOBILE_RES);
  @Input() public inMobile = true;
  @Input() public hasAccess: Maybe<boolean | null>;
  @Input() public link: Maybe<unknown[]>;
}
